export default (theme) => ({
  instructions: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  guideLink: {
    textDecoration: 'none',
    textTransform: 'lowercase',
    color: theme.palette.link.main,
  },
});
